import React, {useState, useEffect, forwardRef, useRef} from 'react';
import { formatCurrency, retardo } from '../../utils/validations';
import { updateTicket } from '../../components/API';
import TableCell from '@mui/material/TableCell'; //actualziacion nodejs
import TableRow from '@mui/material/TableRow'; //actualziacion nodejs
import Fade from '@mui/material/Fade'; //actualziacion nodejs
import { styled } from '@mui/material/styles'; //actualziacion nodejs
import Button from '@mui/material/Button'; //actualizacion node js
import Divider from '@mui/material/Divider'; //actualizacion nodejs
import Card from '@mui/material/Card'; //actualizacion nodejs
import CardContent from '@mui/material/CardContent'; //actualizacion nodejs
import Typography from '@mui/material/Typography'; //actualizacion nodejs
import Dialog from '@mui/material/Dialog'; //actualizacion nodejs
import DialogActions from '@mui/material/DialogActions'; //actualizacion nodejs
import DialogContent from '@mui/material/DialogContent'; //actualizacion nodejs
import DialogContentText from '@mui/material/DialogContentText'; //actualizacion nodejs
import DialogTitle from '@mui/material/DialogTitle'; //actualizacion nodejs
import Snackbar from '@mui/material/Snackbar'; //actualizacion nodejs
import MuiAlert from '@mui/material/Alert'; //actualizacion nodejs
import CircularProgress from '@mui/material/CircularProgress'; // spinner for upload
import { useSelector, useDispatch } from 'react-redux';
import types from '../../actions/types';
import CreatePDF from '../../components/PDF';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from 'moment';
import 'moment/locale/es';
import './index.css'
import firebase from '../../utils/firebase';
import 'firebase/storage';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

export default function Ticket(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const fileInputRefTicket = useRef();
  const [localComprobanteName, setLocalComprobanteName] = useState('Sin comprobante');
  const [localComprobanteLoaded, setLocalComprobanteLoaded] = useState(false);
  let { data: { cliente, facturas_abono, forma_Pago, cliente_nombre,
    importe_total, moneda_pago, num_ticket, guardado_sap,
    fecha_abono, vendedor, enFirebase, id_ticket, tipo, cancelado,
    comentarios, refBanco, tipo_cambio, referencia, vendedor_nombre,
    rechazado, folioRechazo, comentariosRechazo, fechaRechazo}, index } = props;
  let fecha = moment(fecha_abono).format('LLL') ;
  let { data } = props;
  const {syncs} =  useSelector((state)=>{ return state })
  let logo = syncs.configuracion.logo;
  let masDeUna = facturas_abono.length > 1? true: false;
  const [mensaje, setMensaje] = useState('');
  const [visible, setVisible] = useState(false);
  const [snackDuration, setSnackDuration] = useState(3000);
  const [uploadingComprobante, setUploadingComprobante] = useState(false);
  const [visibleDiv, setVisibleDiv] = useState(false);
  const dispatch  = useDispatch();
  const [otrasFact, setOtrasFact] = useState([]);
  const [print, setPrint] = useState(false);
  const [open, setOpen] = useState(false);
  moment.locale('es');
  let alertOnchange = () =>{setModalVisible(!modalVisible); }
  let puedeCancelar = moment(fecha_abono).format('L') === moment().format('L') && moment().format('HH:mm:ss') <"22:00" && cancelado === "0"? false:true;

  const CustomDiv = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    //padding: theme.spacing(2, 4, 3),
    marginRight:40,
    marginLeft:40,
    marginTop:10,
    paddingBottom:20,
    borderRadius:10,
    borderWidth: 1,
    outline: 'none',
    maxWidth: 400,
  }));

  const Subtitle = styled('p')(({ theme }) => ({
    fontSize: 16,
    marginBottom: 0
  }));
    
  const handleCloseAle = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setVisible(false);
  };
  
  const handleClosePdf = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setPrint(false);
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setOpen(false);
  };

  const validFileTypeTicket = (name, type) => {
    const allowedExt = ['png','jpeg','jpg','pdf'];
    const parts = name.split('.');
    const ext = parts.length>1? parts.pop().toLowerCase() : '';
    if (allowedExt.includes(ext)) return true;
    if (type && type.indexOf('image') !== -1) return true;
    return false;
  }

  const triggerSelectComprobanteTicket = () => {
    if (fileInputRefTicket && fileInputRefTicket.current) fileInputRefTicket.current.click();
  }

  

  const handleSelectComprobanteTicket = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const file = files[0];
    const name = file.name || '';
    if (!validFileTypeTicket(name, file.type)){
      setMensaje('error! solo formatos de imagen');
      setVisible(true);
      return;
    }
    setUploadingComprobante(true);
    // default snack duration for errors/other messages
    setSnackDuration(3000);
    try{
      // Si exite la URL, lo borra y evite duplicados 1.7.0
      if (data && Object.prototype.hasOwnProperty.call(data, 'comprobante_url') && data.comprobante_url){
        try{
          const oldRef = firebase.storage().refFromURL(data.comprobante_url);
          await oldRef.delete();
        }catch(err){
          console.warn('No se pudo borrar comprobante previo o no existe:', err);
        }
      }

      const { vendedor } = syncs && syncs.vendedor? syncs: {};
      const num_vendedor = vendedor && vendedor.numero_vendedor? vendedor.numero_vendedor : vendedor;
      // always use the new file's extension for the uploaded filename
      // previous file (if any) was already deleted above, so we should upload
      // the new file with its actual extension to avoid mismatches
      const extParts = (name || '').split('.');
      const ext = extParts.length > 1 ? extParts.pop().toLowerCase() : '';
      const fileName = `${num_ticket}_${num_vendedor}` + (ext ? `.${ext}` : '');
      const storagePath = `COMPROBANTES/${fileName}`;
      const storageRef = firebase.storage().ref().child(storagePath);
      const snapshot = await storageRef.put(file);
      const url = await snapshot.ref.getDownloadURL();

      // persist comprobante_url immediately in Firestore so URL isn't lost
      try{
        const db = firebase.firestore();
        await db.collection('tickets').doc(id_ticket).update({ comprobante_url: url, actualizar: "1" });
      }catch(err){
        console.error('Error actualizando ticket en Firestore:', err);
      }
      // update ticket data locally in Redux
      let newData = Object.assign({}, data);
      newData.comprobante_url = url;
      newData.actualizar = "1";
      const { tickets } = syncs;
      let tmpTickets = await tickets.slice().filter(elm => elm.id_ticket !== id_ticket);
      tmpTickets.push(newData);

      setLocalComprobanteName(name);
      setLocalComprobanteLoaded(true);
      // success message: show for 10 seconds with green filled alert
      setMensaje('Comprobante Enviado/Actualizado');
      setSnackDuration(20000);
      setVisible(true);
      // dispatch slightly delayed so Snackbar has time to render (avoids unmount hiding it)
      setTimeout(() => {
        dispatch({type:"TICKETS_UPDATE", payload: { ticket: tmpTickets } });
      }, 2500);
    }catch(err){
      console.error('Error subiendo comprobante del ticket:', err);
      setMensaje('Error al subir comprobante');
      setSnackDuration(3000);
      setVisible(true);
    } finally {
      setUploadingComprobante(false);
    }
  }


  async function cancelar (){
    //console.log(id_ticket)
    let newData = Object.assign({}, data);
    newData.cancelado = "1";
    newData.actualizar = "1";
    newData.fechaCancelado = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    const { tickets } = syncs;
    let tmpTickets = await tickets.slice().filter(elm => elm.id_ticket !== id_ticket);
    tmpTickets.push(newData)
    let mensaje = await updateTicket ( newData );
    setMensaje(mensaje);
    setVisible(true)
    dispatch({type:"TICKETS_UPDATE", payload: { ticket: tmpTickets } });
    setOpen(false);
  }

  useEffect(() => {
    // no-op: previous attempt to persist modal open was reverted
  }, []);

  useEffect(() => {
    async function fetchData() {
      let data = await syncs.clientes;
      let clienteF = await data.filter(element => element.KUNNR === cliente)[0];
      let b1 = clienteF.facturas; 
      let b2 = facturas_abono;
      let resa = cliente.KTOKD === "ZPGL"? []:b1.filter(item1 => !b2.some(item2 => (item2.BELNR === item1.BELNR )));
      setOtrasFact(resa);
    }
    fetchData();
  }, []);

  async function generarPDF (){
    setPrint(true);
    window.scrollTo(0, 0)
    await retardo(1000);
    setPdf()
  }

  function setPdf(){
    let input = document.getElementById('pdfdiv');
    let divHeight = input.clientHeight>1200?1200:input.clientHeight;
    let divWidth = input.clientWidth
    let ratio = divHeight / divWidth;
    //console.log("quepedo", divHeight, divWidth, ratio)
      html2canvas(input, { scale: '2',  }).then((canvas) => {
      let imgData = canvas.toDataURL('');
      let pdfDOC = new jsPDF("p", "pt", "a4");
      let width = pdfDOC.internal.pageSize.getWidth();
      let height = pdfDOC.internal.pageSize.getHeight();
      height = ratio * width;      
      pdfDOC.addImage(imgData, 'JPEG', 25, 0, width - 20, height - 10);
      pdfDOC.save(id_ticket + ".pdf");
      // wait longer before hiding the print dialog so user sees the result (9s)
      setTimeout(() => {
        setVisibleDiv(false);
        // do NOT close the ticket modal automatically; user will close it manually
        setPrint(false);
      }, 9000);
      })
  }

  return (
    <>
      <Dialog
        sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalVisible}
        onClose={alertOnchange}
        disableEscapeKeyDown
        scroll='paper'
        key={"modal " + index + id_ticket}
        //scroll='paper' //actualizacion nodejs
      >
        <Fade in={modalVisible}>
          <CustomDiv >
            <h2 className="transition-modal-title">Datos del ticket</h2>
            <Subtitle id="transition-modal-description" >{`Ticket: ${num_ticket}`}</Subtitle>
            <Subtitle id="transition-modal-description" >{`Cliente: ${cliente_nombre}`}</Subtitle>
            <Subtitle id="transition-modal-description" >{`Numero cliente: ${cliente}`}</Subtitle>
            <Subtitle id="transition-modal-description" >{`Importe: ${formatCurrency(importe_total)}`}</Subtitle>
            <Subtitle id="transition-modal-description" >{`Moneda: $${moneda_pago}`}</Subtitle>
            <Subtitle id="transition-modal-description" >{`Forma de pago: ${forma_Pago}`}</Subtitle>
            {referencia?
              <>
                <Subtitle id="transition-modal-description" >{`Referencia: ${referencia}`}</Subtitle>
              </>:""
            }
            <Subtitle id="transition-modal-description" >{`Referencia de Pago: ${refBanco? refBanco: "No registrada"}`}</Subtitle>
            <Divider />   
            <Subtitle id="transition-modal-description" >{`${masDeUna?"Facturas abonadas:":  "Factura abonada:"}`}</Subtitle>   
            <div>
              {facturas_abono.map(element => {
                return(
               <React.Fragment key={element.BELNR}>
                <>  
                  <Subtitle id="transition-modal-description" >-------------------------------------</Subtitle>
                  <Subtitle id="transition-modal-description" >Folio: {element.BELNR}</Subtitle>
                  <Subtitle id="transition-modal-description" >Total {formatCurrency(element.DMBTR)}</Subtitle>
                  <Subtitle id="transition-modal-description" >Saldo: {formatCurrency(element.tmp_saldo)}</Subtitle>
                  <Subtitle id="transition-modal-description" >Abonado: {formatCurrency(element.abono)}</Subtitle>
                  {element.DMBTR !== "0"?
                    <Subtitle id="transition-modal-description" >Restante: {formatCurrency(element.tmp_saldo - element.abono)}</Subtitle>:"" }
                </>
                </React.Fragment>
                );
              
              })}
              <Subtitle id="transition-modal-description" >-------------------------------------</Subtitle>
            </div>
            {cancelado && cancelado === "0" && rechazado && rechazado === "0"?
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: 10,
                marginBottom: 10,
              }}>
                { /* show comprobante uploader only if ticket data contains the field */ }
                { Object.prototype.hasOwnProperty.call(data, 'comprobante_url') ? (
                  <div style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 10}}>
                    <input
                      type="file"
                      ref={fileInputRefTicket}
                      style={{display:'none'}}
                      accept=".png,.jpeg,.jpg,.pdf"
                      onChange={handleSelectComprobanteTicket}
                    />
                    <Button 
                      variant="contained" 
                      color="primary" 
                      style={{alignSelf: 'center', width: '100%'}}
                      onClick={triggerSelectComprobanteTicket}
                      disabled={uploadingComprobante}
                    >
                      <span style={{display:'inline-flex', alignItems:'center', justifyContent:'center', width: '100%'}}>
                        {data.comprobante_url === null ? 'Selecciona comprobante' : 'Actualizar comprobante'}
                        {uploadingComprobante ? <CircularProgress size={18} style={{marginLeft:8, color:'#3f51b5'}} /> : null}
                      </span>
                    </Button>
                    <div style={{marginTop:8}}>
                      {data.comprobante_url === null ? (
                        <span>Sin comprobante</span>
                      ) : (
                        <span style={{color:'green', display:'flex', alignItems:'center', gap:6}}><CheckCircleIcon style={{color:'green', marginRight:6}}/>Entregado</span>
                      )}
                    </div>
                  </div>
                ) : null }
                <Button 
                variant="contained" 
                color="primary" 
                style={{alignSelf: 'center', width: '100%'}}
                onClick={() => { generarPDF(); }}
                >Generar PDF</Button><br />
                <Button 
                variant="contained" 
                color="primary" 
                style={{alignSelf: 'center', width: '100%'}}
                disabled={puedeCancelar} 
                onClick={() => { setOpen(true); }}>Cancelar ticket</Button>
              </div>:
              rechazado && rechazado === "1"?
              <>
              <Subtitle id="transition-modal-description" >{`Fecha rechazo: ${fechaRechazo}`}</Subtitle>
              <Subtitle id="transition-modal-description" >{`Folio de rechazo: ${folioRechazo}`}</Subtitle>
              <Subtitle id="transition-modal-description" >{`Motivo: ${comentariosRechazo}`}</Subtitle>
                <Button 
                  variant="contained" 
                  color="primary" 
                  style={{alignSelf: 'center', width: '100%'}}
                  onClick={() => { generarPDF(); }}
                  >Generar PDF</Button><br/><br/>
              </>
              :        
              <Typography sx={{color:'red', fontSize: 18}} >
                {cancelado && cancelado !== "0"
                  ? "Cancelado"
                  : `${enFirebase && enFirebase === "1"? "Guardado en la nube": "Guardado localmente"}`
                }
              </Typography>
              }
            <div style={{justifyContent: "flex-end", alignItems: "flex-end", display: "flex"}}>
              <Button  
                variant="contained" 
                color="primary" 
                onClick={() => { setModalVisible(!modalVisible); }}
                style={{alignSelf: 'center', width: '100%'}}
              > Ok </Button>
            </div>
          </CustomDiv>
        </Fade>
      </Dialog> 
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        key={"dialogo" + num_ticket}
        scroll='paper'
        disableEscapeKeyDown
      >
        <DialogTitle id="alert-dialog-title">Cancelar ticket</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Deseas cancelar el ticket? 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{cancelar()}} color="primary">
            Sí
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <TableRow hover role="checkbox" style={{cursor: "pointer",}} tabIndex={-1} key={index + num_ticket} onClick={() => { setModalVisible(true); }}>
      <TableCell key={num_ticket} align={"center"} sx={{padding:'5px'}}> 
        <Card sx={{minWidth: 275, maxHeight: 190 }}>
          <CardContent sx={{padding:'0px', '&:last-child': { paddingBottom: '10px' }}}>
            <Typography sx={{ fontSize: 15}}>
              <span style={{display:'inline-flex', alignItems:'center'}}>
                {`Ticket: ${vendedor +"_" +num_ticket}`}
                { Object.prototype.hasOwnProperty.call(data, 'comprobante_url') ? (
                  data.comprobante_url === null ? (
                    <WarningAmberIcon style={{color:'#ff9800', marginLeft:8, fontSize:18}} />
                  ) : (
                    <ReceiptLongIcon style={{color:'green', marginLeft:8, fontSize:18}} />
                  )
                ) : null }
              </span>
              <br />
              {`Importe: ${formatCurrency(importe_total)}`}<br />
              {`Fecha: ${ moment(fecha_abono).format('LLLL') }`}<br />
              {tipo && tipo === types.ANTICIPO? types.FORMA_ABONO: tipo && tipo === types.MIXTO? types.FORMA_MIXTO: types.FORMA_FATURAS}<br />
            </Typography>
            <Typography
              sx={{
                color: cancelado && cancelado !== "0" || rechazado && rechazado !== "0" ? 'red' : '',
                fontSize: 18,
              }}
            >
            {cancelado && cancelado !== "0"
              ? "Cancelado"
              : `${rechazado && rechazado !== "0"? "Cheque rechazado": guardado_sap === "0"? types.SAP_LOCAL: types.SAP_SEND}`
            }
            </Typography>
          </CardContent>
        </Card>
        </TableCell>
      </TableRow>
      <Dialog
        open={print}
        onClose={handleClosePdf}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        key={"dialogoPDF_" + num_ticket}
        disableEscapeKeyDown
        maxWidth="lg"
      >
        {print?<CreatePDF pdf={data} reimpresion={true} key={"ticket" + id_ticket} otrasFact={otrasFact}/>:null}
      </Dialog>
      <Snackbar open={visible} autoHideDuration={snackDuration} onClose={handleCloseAle} key={"alert" + id_ticket} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleCloseAle} severity={mensaje && mensaje.toString().toLowerCase().includes('error') ? 'error' : 'success'}>
          {mensaje}
        </Alert>
      </Snackbar>
    </>
  );
};